export default "__VITE_ASSET__wt9$KAFc__"